
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartFourShadesProposal as ObiChartFourShadesProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-four-shades-proposal.js';
 
 
 

 
 export const ObiChartFourShadesProposal = createComponent({
   react: React,
   tagName: 'obi-chart-four-shades-proposal',
   elementClass: ObiChartFourShadesProposalElement,
   events: {
     
   }
  });
 
 